<template>
    <div class="uk-width-1-6@l uk-width-1-4@m uk-width-1-3@s">
        <a :href="photohref" data-alt="Image"><img :src="url"></a>
        <div class="uk-container">
            <div class="uk-flex uk-text-small uk-text-center uk-child-width-1-3 uk-margin-bottom">
                <div class="uk-text-left"><div v-bind:class="{ on: isHeartOn }" class="tag-label uk-icon heart-icon" uk-icon="heart" @click="clickHeart(p.id)"></div> {{ p.hearts }}</div>

                <div class="uk-text-center tag-label" uk-icon="pencil" v-if="p.editable" @click="clickEdit(p.id)"></div>
                <div class="uk-text-center" uk-icon="" v-else></div>

                <div class="uk-text-right tag-label" uk-icon="trash" @click="dialogVisible = true" v-if="p.editable"></div>
                <div class="uk-text-right" uk-icon="" v-else></div>
            </div>
            <div>
                <span class="tag uk-label uk-label-success uk-margin-small-right tag-label" v-for="tag in p.tags" v-bind:key="tag" @click="tagClick('tag', tag)">{{ tag }}</span>
            </div>
            <div>
                <span class="area uk-label uk-label-primary uk-margin-small-right tag-label" v-for="area in p.areas" v-bind:key="area" @click="tagClick('area', area)">{{ area }}</span>
            </div>
            <div>
                <span class="member uk-label uk-label-warning uk-margin-small-right tag-label" v-for="member in p.members" v-bind:key="member" @click="tagClick('member', member)">{{ member }}</span>
            </div>

            <el-dialog
                title="ゴミ箱"
                :visible.sync="dialogVisible">
                <div class="uk-grid-medium" uk-grid>
                    <div class="uk-width-1-4@m uk-width-1-2@s">
                        <img :src="url" >
                    </div>
                    <div class="uk-width-3-4@m uk-width-1-2@s">
                        <span>この写真を削除しますか？</span>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelTrash">キャンセル</el-button>
                    <el-button type="primary" @click="clickTrash">削除する</el-button>
                </span>
            </el-dialog>

        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    name: 'photoBlock',
    components: {
    },
    props: {
        photo: {},
    },
    data: function () {
        return {
            p: this.photo,
            url: String,
            photohref: String,
            dialogVisible: false,
            isHeartOn: this.photo.my_heart,
        }
    },
    methods: {
        tagClick: function (key, value) {
            var url = '/tag/?' + key + '=' + value
            this.$router.push(url)
        },
        clickHeart: function(id) {
            let url = this.$config.common.apiPath + '/setHeart/?id=' + this.p.id
            this.$axios.get(
                url
            )
            .then(response => {
                if (response.data.status == 'INSERT') {
                    this.isHeartOn = true
                } else if (response.data.status == 'DELETE') {
                    this.isHeartOn = false
                }
            })
            .catch( function(error){
                // TODO
            })
        },
        clickEdit: function(id) {
            var url = '/edit/?id=' + id
            this.$router.push(url)
        },
        clickTrash: function() {
            let url = this.$config.common.apiPath + '/deletePhoto/?id=' + this.p.id
            this.$axios.get(
                url
            )
            .then(response => {
                // NOP
            })
            .catch( function(error){
                // TODO
            })
            this.dialogVisible = false

            this.$store.dispatch('updateFullList', this.$config.common.apiPath)
        },
        cancelTrash: function(id) {
            this.dialogVisible = false
        },
/* --
        handleClose(done) {
            this.$confirm('Are you sure to close this dialog?')
            .then(_ => {
                alert('OK')
            })
            .catch(_ => {
                alert('NG')
            })
        }
-- */
    },
    watch: {
        isHeartOn: function (newStatus, oldStatus) {
            if (newStatus) {
                this.p.hearts++
            } else {
                this.p.hearts--
            }
        }
    },
    mounted () {
        this.url = this.$config.common.apiPath + '/square/?f=' + this.p.photo
        this.photohref = this.$config.common.photoPath + this.p.photo
    }
}
</script>

<style>
.tag-label {
    cursor: pointer;
}
.area {
    background-color: #FFE4A8;
    color: #444;
    border: 1px solid transparent;
}
.member {
    background-color: #412554;
    color: #fff;
    border: 1px solid transparent;
}
.tag {
    background-color: #008B52;
    color: #fff;
    border: 1px solid transparent;
}
@media screen and (max-width: 640px) {
    .el-dialog {
        width: 80%!important;
    }
}
@media screen and (min-width: 640px) {
    .el-dialog {
        width: 50%!important;
    }
}
.heart-icon {
    color: #FF0000;
}

.on.uk-icon[uk-icon="heart"] svg path {
    fill: #ff0000;
}
</style>
